<template>
  <div>
    <slot name="activator" :open="open">
      <oie-base-action
        v-tooltip.top="t('myUsersAddUserTooltip')"
        theme="flat"
        :only-icon-mobile="true"
        @click="open">
        <template #iconPrepend>
          <oie-base-icon icon="user-follow"></oie-base-icon>
        </template>
        {{ t('myUsersAddUserLabel') }}
      </oie-base-action>
    </slot>
    <oie-portal-wrapper :name="name">
      <template #title>
        <h2>{{ t('myUsersInviteUserTitle') }}</h2>
      </template>
      <validation-observer ref="observer" tag="div">
        <oie-form-wrapper class="input-column__container" @submit="inviteUser">
          <div v-html="t('myUsersInviteUserInfoText')"></div>
          <validation-provider
            v-slot="{errors}"
            vid="email"
            slim
            rules="required|email">
            <oie-base-input v-model="email" :label-text="tStatic('email')" :error-messages="errors"></oie-base-input>
          </validation-provider>
          <oie-base-action type="submit">
            {{ t('myUsersSendInviteButtonLabel2') }}
          </oie-base-action>
        </oie-form-wrapper>
      </validation-observer>
    </oie-portal-wrapper>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import httpService from '@/core/http-service'
import _ from 'lodash'

export default {
  data() {
    return {
      name: '',
      email: ''
    }
  },
  beforeMount() {
    this.name = this.$attrs.id || _.uniqueId('invite-user')
  },
  methods: {
    ...mapActions('ui', ['setActiveSlideIn']),
    open() {
      this.setActiveSlideIn(this.name)
    },
    async inviteUser() {
      const isValid = await this.$refs.observer.validate()
      if(!isValid) return

      httpService.post('auth/myusers/invite', { email: this.email }).then((response) => {
        this.setActiveSlideIn(null)
        this.publish('my-users-invited-new-user')
        this.email = ''
      }).catch((error) => {
        // The address already belongs to a user. The notification bar shows the server's message
        // too, but it goes away; this stays under the field until the address is changed (OC-3039).
        if (error.response && error.response.status === 409) {
          this.$refs.observer.setErrors({ email: [this.t('myUsersInvitedUserAlreadyExists').replace('{0}', this.email)] })
        }
      })
    }
  }
}
</script>

<style>

</style>
